import React from 'react'
import { Divider, Typography } from 'antd'
import SendToFinishing from '../../../components/Kanban-Count-Accuracy/SendToFinishing/SendToFinishing'

const KanbanCountAccuracyKanbanScanPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Send to Finishing
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <SendToFinishing />
        </>
    )
}

export default KanbanCountAccuracyKanbanScanPage